/**
 * 安全地执行异步函数，不会抛错
 */
export const safeAsync = async <T>(
  asyncFn: () => Promise<T>,
  errHandler?: (error: unknown) => void,
): Promise<T | null> => {
  try {
    return await asyncFn();
  } catch (err) {
    errHandler?.(err);
    return null;
  }
};
